/**
 * Servicio para gestión de catálogo de modelos
 */

import api from './api.js';

class ModeloService {
  /**
   * Listar modelos con filtros
   */
  async listar(params = {}) {
    // Limpiar parámetros vacíos
    const cleanParams = {};
    Object.keys(params).forEach(key => {
      if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
        cleanParams[key] = params[key];
      }
    });
    return await api.get('/modelos', cleanParams);
  }

  /**
   * Listar solo modelos activos (para selects)
   */
  async listarActivos() {
    return await api.get('/modelos/activos');
  }

  /**
   * Obtener marcas únicas (para cascada)
   */
  async obtenerMarcas() {
    return await api.get('/modelos/marcas');
  }

  /**
   * Obtener modelos por marca (para cascada)
   */
  async obtenerPorMarca(marca) {
    return await api.get(`/modelos/marca/${encodeURIComponent(marca)}`);
  }

  /**
   * Obtener modelo por ID
   */
  async obtenerPorId(id) {
    return await api.get(`/modelos/${id}`);
  }

  /**
   * Crear nuevo modelo
   */
  async crear(data) {
    return await api.post('/modelos', data);
  }

  /**
   * Actualizar modelo
   */
  async actualizar(id, data) {
    return await api.put(`/modelos/${id}`, data);
  }

  /**
   * Activar/Desactivar modelo
   */
  async toggleActivo(id) {
    // Para PATCH usamos fetch directamente ya que api.js no tiene método patch
    const response = await fetch(`${api.baseUrl}/modelos/${id}/toggle`, {
      method: 'PATCH',
      headers: api.getHeaders()
    });
    return await api.handleResponse(response);
  }

  /**
   * Eliminar modelo
   */
  async eliminar(id) {
    return await api.delete(`/modelos/${id}`);
  }

  /**
   * Obtener estadísticas
   */
  async obtenerEstadisticas() {
    return await api.get('/modelos/stats');
  }
}

export default new ModeloService();
